module.exports = __webpack_public_path__ + "img/CITYcmyk.f780da3f.jpg";